export { RegistrationFormComponent } from './registration-form/registration-form.component';
